import {ObjectDTO} from "../object-dto";
import {TypeUtilisateurPmsDto} from "./type-utilisateur-pms-dto";

export class SignatureUtilisateurPmsDto extends ObjectDTO {
  nom: string;
  prenom: string;
  image: File;
  typeUtilisateurPmsList: TypeUtilisateurPmsDto[];
}
